var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.695d29fffcc5c4ef439f3a727463914c.svg#b';
                    var viewUrl = 'sprites.695d29fffcc5c4ef439f3a727463914c.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 640 151',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };